export let FromWorkerMessageTypes;
(function (FromWorkerMessageTypes) {
  FromWorkerMessageTypes["FROM_WORKER_UPDATED_WIDGET_DETAILS"] = "FROM_WORKER_UPDATED_WIDGET_DETAILS";
  FromWorkerMessageTypes["FROM_WORKER_UPDATED_PROVIDER_DETAILS"] = "FROM_WORKER_UPDATED_PROVIDER_DETAILS";
  FromWorkerMessageTypes["FROM_WORKER_STANDALONE_HEARTBEAT"] = "FROM_WORKER_STANDALONE_HEARTBEAT";
  FromWorkerMessageTypes["FROM_WORKER_ACTIVE_CALL_CONNECTION_PING"] = "FROM_WORKER_ACTIVE_CALL_CONNECTION_PING";
})(FromWorkerMessageTypes || (FromWorkerMessageTypes = {}));
export let DeprecatedFromWorkerMessageTypes;
(function (DeprecatedFromWorkerMessageTypes) {
  DeprecatedFromWorkerMessageTypes["FROM_WORKER_UPDATED_APPDATA"] = "FROM_WORKER_UPDATED_APPDATA";
})(DeprecatedFromWorkerMessageTypes || (DeprecatedFromWorkerMessageTypes = {}));
export function isFromWorkerMessageType(type) {
  return type in FromWorkerMessageTypes;
}
export function isFromWorkerStandaloneHeartbeat(message) {
  return message && message.type === FromWorkerMessageTypes.FROM_WORKER_STANDALONE_HEARTBEAT;
}
export function isFromWorkerActiveCallConnectionPing(message) {
  return message && message.type === FromWorkerMessageTypes.FROM_WORKER_ACTIVE_CALL_CONNECTION_PING;
}
export function isFromWorkerUpdatedWidgetDetailsMessage(message) {
  return message.type === FromWorkerMessageTypes.FROM_WORKER_UPDATED_WIDGET_DETAILS;
}
export function isFromWorkerUpdatedProviderDetailsMessage(message) {
  return message.type === FromWorkerMessageTypes.FROM_WORKER_UPDATED_PROVIDER_DETAILS;
}
export function isFromWorkerMessage(message) {
  return message.type in FromWorkerMessageTypes;
}
/**
 * @deprecated We no longer use this message and the from value is no longer true.
 */
export function isFromWorkerUpdatedAppDataMessage(message) {
  return message.type === DeprecatedFromWorkerMessageTypes.FROM_WORKER_UPDATED_APPDATA;
}